function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M438.48 58.61a130.815 130.815 0 00-95.573-41.711 130.968 130.968 0 00-95.676 41.694l-8.431 8.909-8.431-8.909C181.282 5.762 98.659 2.728 45.829 51.815a130.901 130.901 0 00-6.778 6.778c-52.072 56.166-52.072 142.97 0 199.13l187.36 197.58c6.482 6.843 17.284 7.136 24.127.654.224-.212.442-.43.654-.654l187.29-197.58c52.068-56.16 52.068-142.96-.001-199.12zm-24.695 175.62h-.017l-174.97 184.54-174.98-184.54c-39.78-42.916-39.78-109.23 0-152.15 36.125-39.154 97.152-41.609 136.31-5.484a96.482 96.482 0 015.484 5.484l20.804 21.948c6.856 6.812 17.925 6.812 24.781 0l20.804-21.931c36.125-39.154 97.152-41.609 136.31-5.484a96.482 96.482 0 015.484 5.484c40.126 42.984 40.42 109.42 0 152.13z"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 477.53 477.53"
  }, props), _ref);
}

export default SvgHeart;